import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store/store';
import { setPaymentMode } from 'store/ticket-service/ticketSlice';
import { clearPaymentStatus } from 'store/user-service/userSlice';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

export const PaymentCancelModal = () => {
	const { t: paymentTranslate } = useTranslation(NamespacesList['payment']);

	const dispatch = useAppDispatch();
	const [open, setOpen] = useState<boolean>(true);

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<InfoModal
			isOpen={open}
			onClose={handleClose}
			image={<Error />}
			title={paymentTranslate('modals.paymentCancel.title')}
			description={paymentTranslate('modals.paymentCancel.description')}
			buttons={
				<>
					<Button
						sx={{
							height: '44px',
							width: { xs: '49%', sm: '215px' },
							borderRadius: '8px',
							textTransform: 'none',
							fontSize: '16px',
							fontWeight: '700',
							marginTop: '24px',
						}}
						variant="outlined"
						color="primary"
						onClick={() => {
							dispatch(clearPaymentStatus());
							handleClose();
						}}
					>
						{paymentTranslate('modals.paymentCancel.decline')}
					</Button>

					<Button
						sx={{
							height: '44px',
							width: { xs: '49%', sm: '215px' },
							borderRadius: '8px',
							textTransform: 'none',
							fontSize: '16px',
							fontWeight: '700',
							marginTop: '24px',
						}}
						variant="contained"
						color="primary"
						onClick={() => {
							dispatch(clearPaymentStatus());
							dispatch(setPaymentMode(true));
							handleClose();
						}}
					>
						{paymentTranslate('modals.paymentCancel.confirm')}
					</Button>
				</>
			}
		></InfoModal>
	);
};
